<template>
  <component
    :is="props.tag"
    class="pflege-step-wrapper"
  >
    <PflegeStep
      v-for="(item, index) in props.steps"
      :key="index"
      :icon="item.icon"
      :icon-color="item.iconColor"
      :text-align="item.textAlign"
    >
      <slot name="item" :item="item" :index="index"></slot>
    </PflegeStep>
    <slot></slot>
  </component>
</template>

<script setup lang="ts" generic="T extends StepProps">
import { VNode } from 'vue';
import PflegeStep from '../Step'
import { StepProps } from '../Step/Step.vue'

const props = withDefaults(defineProps<{
  steps?: T[]
  tag?: string
}>(), {
  steps: () => [],
  tag: 'ul',
})

defineSlots<{
  item?(props: { item: T, index: number }): VNode
  default?(): VNode
}>()
</script>
<style scoped lang="scss">
.pflege-step-wrapper {
  counter-reset: StepCounter;
}
</style>
